export default {
  links: {
    addresses: 'Addressbuch',
    logout: 'Ausloggen',
    bankDetails: 'Bankverbindung',
    ceo: 'Geschäftsführer',
  },
}
